import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Paper, Container, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import emailOutline from '@iconify/icons-eva/email-outline';
import phoneOutline from '@iconify/icons-eva/phone-outline';
import homeOutline from '@iconify/icons-eva/home-outline';
import { ContactForm } from '../components/_dashboard/user';
import { termsData } from '../DATA/DataText';

const useStyles = makeStyles((theme) => ({
  backgroundFix: {
    height: '400px',
    marginTop: 120,
    width: '100%',
    backgroundColor: '#F78181',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  centerTitleContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  centerTitle: {
    width: 400,
    height: 150,
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    '& h1': {
      fontSize: '37px',
      fontWeight: 500,
      color: 'white',
      fontFamily: 'Open Sans, sans-serif'
    },
    '& h3': {
      fontSize: '20px',
      fontWeight: 500,
      color: 'white',
      marginTop: 15
    }
  },
  gridCenterContainer: {
    backgroundColor: 'white',
    margin: '0 auto',
    marginBottom: 70,
    marginTop: -100,
    minHeight: '400px',
    padding: 30,
    alignItems: 'center',
    boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)'
  },
  gridContainer: {
    // backgroundColor: 'pink',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 50,
    marginTop: 100
  },
  text: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '2rem',
    color: 'blak',
    marginTop: 10,
    fontFamily: 'Open Sans, sans-serif'
  },
  title: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '19px',
    fontWeight: 'bold',
    color: '#F78181',
    marginBottom: 10
  },
  list: {
    paddingLeft: 35,
    '& li': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '2rem',
      color: 'blak',
      marginTop: 10,
      fontFamily: 'Open Sans, sans-serif'
    }
  }
}));

const MentionLegal = () => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  return (
    <div>
      <Grid container xs={12} className={classes.backgroundFix}>
        <Box className={classes.centerTitle}>
          <h1>{t('mention')}</h1>
        </Box>
      </Grid>
      <Container maxWidth="md" style={{ marginBottom: 200 }}>
        <Grid container xs={12} className={classes.gridCenterContainer}>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.text}>{t('mention_legales')}</Typography>
          </Box>
        </Grid>
      </Container>
    </div>
  );
};

export default MentionLegal;
